import { Box, Typography, Grid, Paper, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SecurityIcon from "@mui/icons-material/Security";
import LockIcon from "@mui/icons-material/Lock";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import Layout from "../components/layout/LandingPageLayout";
import { Link } from "react-router-dom";

const SecurityInfo = () => {
  const theme = useTheme();

  return (
    <Layout>
      <Box
        sx={{
          py: 8,
          px: 4,
          backgroundColor: theme.palette.background.default,
        }}
      >
        {/* Title */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
        >
          Enterprise-Grade Security
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{
            maxWidth: 700,
            mx: "auto",
            color: theme.palette.text.secondary,
            mb: 6,
          }}
        >
          Your financial data is our top priority. With multi-layered security,
          encryption, and compliance standards, we ensure your information stays
          private, safe, and secure at all times.
        </Typography>

        {/* Security Features */}
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <SecurityIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                End-to-End Encryption
              </Typography>
              <Typography variant="body2" color="text.secondary">
                All your files and transactions are encrypted, ensuring that
                only you and authorized users can access them.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <LockIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Secure Authentication
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Multi-factor authentication and role-based access keep your
                sensitive data protected from unauthorized access.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <VerifiedUserIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Compliance & Standards
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Built with GDPR and industry security standards to ensure
                maximum trust and compliance for your business.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* CTA */}
        <Box textAlign="center" mt={6}>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            size="large"
            sx={{
              backgroundColor: theme.palette.primary.main,
              "&:hover": { backgroundColor: theme.palette.primary.dark },
              px: 5,
              py: 1.5,
              borderRadius: 3,
            }}
          >
            Learn More About Security
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default SecurityInfo;
